export default __webpack_public_path__ + "static/media/logo-castro.be67e1c0.png";